// extracted by mini-css-extract-plugin
export default {"component":"LandDisplayLeft_component__bPtIm","plotImg":"LandDisplayLeft_plotImg__wlzNf","leftTopImg":"LandDisplayLeft_leftTopImg__MC3f1"};